export const addMobileAccountsMutation = (mobileAccounts) => {
    const mutations = mobileAccounts.map((mobileAccount) => {
        const { contactName, phoneNumber } = mobileAccount;

        return `
            addWithdrawalMobileAccount(
                mobileAccounts: {
                    contactName: "${contactName}",
                    phoneNumber: "${phoneNumber}"
                }
            ) {
                success
                errorMessage
                mobileAccounts {
                    id
                    contactName
                    phoneNumber
                }
            }
        `;
    });

    const fullMutation = `
        mutation {
            ${mutations.join('\n')}
        }
    `;

    return fullMutation;
};

export const addBankAccountsMutation = (bankAccounts) => {
    const mutations = bankAccounts.map(account => `
        addWithdrawalBankAccount(
            bankAccounts: {
                accountName: "${account.accountName}",
                accountNumber: "${account.accountNumber}",
                swiftCode: "${account.swiftCode}",
                branchCode: "${account.branchCode}"
            }
        ) {
            success
            errorMessage
            bankAccounts {
                id
                accountName
                accountNumber
                swiftCode
                branchCode
            }
        }
    `).join("\n");

    return `mutation {${mutations}}`;
};

export const updateBankAccountsMutation = (bankAccounts) => {
    const mutations = bankAccounts.map(account => `
        updateWithdrawalBankAccount(
            bankAccounts: {
                id: ${JSON.stringify(account.id)},
                accountName: "${account.accountName}",
                accountNumber: "${account.accountNumber}",
                swiftCode: "${account.swiftCode}",
                branchCode: "${account.branchCode}"
            }
        ) {
            success
            errorMessage
            bankAccounts {
                id
                accountName
                accountNumber
                swiftCode
                branchCode
            }
        }
    `).join("\n");

    return `mutation {${mutations}}`;
};

export const deleteBankAccountsMutation = (bankAccountIds) => {
    return `
        mutation {
            deleteWithdrawalBankAccount(
                bankAccountIds: ${JSON.stringify(bankAccountIds)}
            ) {
                success
                errorMessage
                bankAccounts {
                    id
                    accountName
                    accountNumber
                    swiftCode
                    branchCode
                }
            }
        }
    `;
};

export const updateMobileAccountsMutation = (mobileAccounts) => {
    const mutations = mobileAccounts.map((mobileAccount) => {
        const { contactName, phoneNumber, id } = mobileAccount;

        return `
            updateWithdrawalMobileAccount(
                mobileAccounts: {
                    id: ${JSON.stringify(id)},
                    contactName: "${contactName}",
                    phoneNumber: "${phoneNumber}"
                }
            ) {
                success
                errorMessage
                mobileAccounts {
                    id
                    contactName
                    phoneNumber
                }
            }
        `;
    });

    const fullMutation = `
        mutation {
            ${mutations.join('\n')}
        }
    `;

    return fullMutation;
};

export const deleteMobileAccountsMutation = (mobileAccountIds) => {
    return `
        mutation {
            deleteWithdrawalMobileAccount(
                mobileAccountIds: ${JSON.stringify(mobileAccountIds)}
            ) {
                success
                errorMessage
                mobileAccounts {
                    id
                    contactName
                    phoneNumber
                }
            }
        }
    `;
};

export const queryWithdrawalBankAccounts = () => {
    return `
        query {
            withdrawalBankAccounts {
                id
                accountName
                accountNumber
                swiftCode
                branchCode
            }
        }
    `;
};

export const queryWithdrawalMobileAccounts = () => {
    return `
        query {
            withdrawalMobileAccounts {
                id
                contactName
                phoneNumber
            }
        }
    `;
};

export const queryWalletBalance = () => {
    return `
        query {
            walletBalance
        }
    `;
};

export const SendOtpTypeMutation = (confirmationChannel) => `
  mutation {
    sendOtp(confirmationChannel: "${confirmationChannel}") {
      errorMessage
      successMessage
      success
      authSessionExpiry
      otpCodeExpiry
    }
  }
`;

export const VerifyOtpMutation = (otpCode) => `
  mutation {
    verifyOtp(otpCode: "${otpCode}") {
      errorMessage
      success
    }
  }
`;

export const WithdrawalRequestMutation = (withdrawTo, amount, mobileAccId = "", bankAccId = "") => `
  mutation {
    addWithdrawalRequest(
      withdrawTo: "${withdrawTo}",
      amount: "${amount}",
      mobileAccId: ${JSON.stringify(mobileAccId)},
      bankAccId: ${JSON.stringify(bankAccId)}
    ) {
      errorMessage
      successMessage
      success
    }
  }
`;

export const cancelWithdrawalRequestMutation = (withdrawalId) => {
    return `
        mutation {
            cancelWithdrawalRequest(
                withdrawalId: ${JSON.stringify(withdrawalId)}
            ) {
                success
                errorMessage
                customerWithdrawal {
                    id
                    date
                    initiatedBy
                    sentTo
                    amount
                    status
                }
            }
        }
    `;
};

export const queryWithdrawalRequests = (status = "", search_text = "", offset = "", start_date = "", end_date = "", min_amount = 0, max_amount = 0) => {
    return `
        query {
            withdrawalRequests(
                status: ["${status}"],
                searchText: "${search_text}",
                offset: "${offset}",
                startDate: "${start_date}",
                endDate: "${end_date}",
                minAmount: ${min_amount},
                maxAmount: ${max_amount},
                limit: 50
            ) {
                withdrawals {
                    id
                    date
                    initiatedBy
                    sentTo
                    amount
                    status
                }
                next
                previous
                summary {
                    header
                    body
                    footer
                }
            }
        }
    `;
};

export const queryStatusChoices = () => {
    return `
        query {
            statusChoices
        }
    `;
};